import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Close } from '@mui/icons-material';
import { CityContext } from '../../ContextApi/cityContext';
import { MasterContext } from '../../ContextApi/context';
import { APP_READY_EVENT, NO_PROMO_PATHS, appPlatform, cityPickerBlocking, hiddenRecently, isOldApp, rememberHidden } from './appEnv';
import './AppPromo.css';

// "יש גרסה חדשה לאפליקציה" - רק לגרסאות האפליקציה שלפני 1.0.11. מ-1.0.11 יש לאפליקציה חלון עדכון
// נייטיב משלה, והישנות לא יודעות שיש עדכון.
// - מוצג רק כש-isOldApp() והמתג של הפלטפורמה דלוק (ADMIN: MASTER ← פרטי האתר, appUpdateAndroid /
//   appUpdateIos, מגיעים עם המאסטר). בלי מאסטר (הקריאה נכשלה) - לא מוצג.
// - isOldApp נבדק אחרי SHOW_DELAY ושוב ממש לפני ההצגה, כי window.AshdodApp של הגרסה החדשה מוזרק רק
//   אחרי הטעינה. האירוע 'ashdodapp' מבטל.
// - "עדכן עכשיו" / "אחר כך" / X -> לא מוצג שוב HIDE_DAYS ימים.
// - לא בעמודי הזמנה ותשלום, ולא כשבורר העיר פתוח.

const STORE_KEY = 'amAppUpdateHiddenAt';
const SHOW_DELAY = 5000;
// בגרסאות הישנות ה-InAppBrowser מעביר את הסכמות האלה לחנות של המכשיר. לא https - הוא נפתח בתוך האפליקציה.
const STORE_URL = {
    android: 'market://details?id=com.asdodmenu.app', // בכוונה בלי h - זה המזהה ב-Google Play
    ios: 'itms-apps://apps.apple.com/app/id6471904204',
};
const MASTER_FLAG = { android: 'appUpdateAndroid', ios: 'appUpdateIos' };

const AppUpdatePrompt = () => {
    const location = useLocation();
    const cityCtx = useContext(CityContext);
    const [master] = useContext(MasterContext);
    const [due, setDue] = useState(false);
    const [hidden, setHidden] = useState(() => hiddenRecently(STORE_KEY));
    const [appReady, setAppReady] = useState(false); // הגיע 'ashdodapp' - זו הגרסה החדשה

    useEffect(() => {
        const t = setTimeout(() => { if (isOldApp()) setDue(true); }, SHOW_DELAY);
        const onApp = () => setAppReady(true);
        window.addEventListener(APP_READY_EVENT, onApp);
        return () => {
            clearTimeout(t);
            window.removeEventListener(APP_READY_EVENT, onApp);
        };
    }, []);

    if (!due || hidden || appReady || !master) return null;
    const platform = appPlatform();
    if (!platform || !master[MASTER_FLAG[platform]]) return null;
    // נבדק שוב ממש לפני ההצגה
    if (!isOldApp()) return null;
    if (NO_PROMO_PATHS.some(p => location.pathname.startsWith(p))) return null;
    if (cityPickerBlocking(cityCtx)) return null;

    const close = () => {
        rememberHidden(STORE_KEY);
        setHidden(true);
    };

    const update = () => {
        close();
        window.location.href = STORE_URL[platform];
    };

    return (
        <div className="appPromo" role="dialog" aria-label="עדכון האפליקציה" dir="rtl">
            <button className="appPromoClose" onClick={close} aria-label="סגור">
                <Close fontSize="small" />
            </button>
            <div className="appPromoTitle">יש גרסה חדשה לאפליקציה 🎉</div>
            <div className="appPromoTxt">עדכנו כדי ליהנות מהשיפורים האחרונים</div>
            <div className="appPromoBtns">
                <button className="appPromoMain" onClick={update}>עדכן עכשיו</button>
                <button className="appPromoLater" onClick={close}>אחר כך</button>
            </div>
        </div>
    );
};

export default AppUpdatePrompt;
